module.exports = __webpack_public_path__ + "Example-Players-TrainingCentre.png?aaaaaa93ce603bfd4e8df297701547a2";


//////////////////
// WEBPACK FOOTER
// ./static/Example-Players-TrainingCentre.png
// module id = 347
// module chunks = 0